import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: normal;
  background-color: #1a2429;
  color: #aab2b8;
  border: 1px solid #2c353d;
  border-right: 0;
  padding: 5px 8px;
  border-radius: 10px 0 0 10px;
  flex-grow: 1;
  white-space: nowrap;
`;
